import React from 'react';

import { groupFormatLabel, groupKey, type ScoringGroup } from './scoring-types';

interface Props {
  groups: ScoringGroup[];
  onPick: (group: ScoringGroup) => void;
}

function progressPercent(group: ScoringGroup): number {
  if (group.matchCount === 0) {
    return 0;
  }

  return Math.round((group.playedCount / group.matchCount) * 100);
}

export const ScoringGroupPicker: React.FC<Props> = ({ groups, onPick }) => (
  <div className="scoring-group-picker">
    <p className="scoring-hint">Wybierz grupę, w której grasz.</p>

    {groups.map((group) => (
      <button
        key={groupKey(group)}
        type="button"
        className="scoring-group-card"
        data-testid={`scoring-group-${group.name ?? 'all'}`}
        onClick={() => onPick(group)}
      >
        <span className="scoring-group-card__top">
          <span className="scoring-group-card__name">
            {group.name === null ? 'Wszystkie mecze' : `Grupa ${group.name}`}
          </span>
          <span className="scoring-group-card__count">
            {group.playedCount}/{group.matchCount}
          </span>
        </span>
        <span className="scoring-group-card__rules">{groupFormatLabel(group)}</span>
        <span className="scoring-group-card__bar">
          <span
            className="scoring-group-card__bar-fill"
            style={{ width: `${progressPercent(group)}%` }}
          />
        </span>
      </button>
    ))}
  </div>
);

export default ScoringGroupPicker;
